import { render } from "./VietQrPaymentBlock.vue?vue&type=template&id=923d4f7a&scoped=true&ts=true"
import script from "./VietQrPaymentBlock.vue?vue&type=script&lang=ts"
export * from "./VietQrPaymentBlock.vue?vue&type=script&lang=ts"

import "./VietQrPaymentBlock.vue?vue&type=style&index=0&id=923d4f7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923d4f7a"]])

export default __exports__